import { createEmptyContent } from '@lumapps/wrex/utils/createEmptyContent';
import { normalizeForSlate } from '@lumapps/wrex/utils/normalizeForSlate';

import { LegacyWidgetContributionProps } from '../type';

/**
 * Get the rich text content from the widget properties
 * @param properties
 * @param lang
 */
export function getRichTextFromProperties(properties: LegacyWidgetContributionProps | undefined, lang: string) {
    // From rich text
    const richText = properties?.richText?.[lang]?.children;
    if (richText) {
        return normalizeForSlate(richText);
    }

    // Fallback to empty content
    return createEmptyContent();
}
